<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="5" :domain="domain" :service="firstServiceForDomain" />

                    <vps-details :domain="domain" :serverid="serverid" :subscription="service" dusk="vps-details" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VpsDetails from '../../../../../apps/modules/vps/src/components/VpsDetails';
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';

export default {
    components: {
        HeaderPartial,
        VpsDetails
    },
    mixins: [serviceMixin, servicesPageMixin],
    props: {
        domain: {
            type: String,
            default: null
        },
        serverid: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'vps'
        };
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.vps.title', { domain: this.domain })
        };
    }
};
</script>
